import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import { Checkbox } from '../../../components/ui/Checkbox';

const FilterPanel = ({ filters, onFilterChange, onResetFilters }) => {
  const statusOptions = [
    { value: 'all', label: 'Todos los estados' },
    { value: 'available', label: 'Disponible' },
    { value: 'reserved', label: 'Reservado' },
    { value: 'sold', label: 'Vendido' }
  ];

  const priceRangeOptions = [
    { value: 'all', label: 'Todos los precios' },
    { value: '0-100000', label: 'Hasta S/ 100,000' },
    { value: '100000-200000', label: 'S/ 100,000 - S/ 200,000' },
    { value: '200000-300000', label: 'S/ 200,000 - S/ 300,000' },
    { value: '300000+', label: 'Más de S/ 300,000' }
  ];

  const areaRangeOptions = [
    { value: 'all', label: 'Todas las áreas' },
    { value: '0-150', label: 'Hasta 150 m²' },
    { value: '150-250', label: '150 - 250 m²' },
    { value: '250-350', label: '250 - 350 m²' },
    { value: '350+', label: 'Más de 350 m²' }
  ];

  const orientationOptions = [
    { value: 'all', label: 'Todas las orientaciones' },
    { value: 'Norte', label: 'Norte' },
    { value: 'Sur', label: 'Sur' },
    { value: 'Este', label: 'Este' },
    { value: 'Oeste', label: 'Oeste' }
  ];

  return (
    <div className="bg-card rounded-xl shadow-lg p-4 md:p-6 h-full overflow-auto">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
            <Icon name="Filter" size={20} color="var(--color-primary)" />
          </div>
          <h3 className="text-lg md:text-xl font-semibold">Filtros</h3>
        </div>
        <button
          onClick={onResetFilters}
          className="text-sm text-primary hover:text-primary/80 transition-smooth focus-ring rounded px-2 py-1"
        >
          Limpiar
        </button>
      </div>
      {/* Search by Lot Number */}
      <div className="mb-6">
        <Input
          label="Buscar por número de lote"
          type="text"
          placeholder="Ej: 101, 102..."
          value={filters?.lotNumber}
          onChange={(e) => onFilterChange('lotNumber', e?.target?.value)}
          className="mb-0"
        />
      </div>
      {/* Status Filter */}
      <div className="mb-6">
        <Select
          label="Estado"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />
      </div>
      {/* Price Range Filter */}
      <div className="mb-6">
        <Select
          label="Rango de precio"
          options={priceRangeOptions}
          value={filters?.priceRange}
          onChange={(value) => onFilterChange('priceRange', value)}
        />
      </div>
      {/* Area Range Filter */}
      <div className="mb-6">
        <Select
          label="Rango de área"
          options={areaRangeOptions}
          value={filters?.areaRange}
          onChange={(value) => onFilterChange('areaRange', value)}
        />
      </div>
      {/* Orientation Filter */}
      <div className="mb-6">
        <Select
          label="Orientación"
          options={orientationOptions}
          value={filters?.orientation}
          onChange={(value) => onFilterChange('orientation', value)}
        />
      </div>
      {/* Layer Toggles */}
      <div className="mb-6">
        <h4 className="text-sm font-medium mb-4">Capas del plano</h4>
        <div className="space-y-3">
          <Checkbox
            label="Mostrar servicios"
            description="Agua, luz, desagüe"
            checked={filters?.showUtilities}
            onChange={(e) => onFilterChange('showUtilities', e?.target?.checked)}
          />
          <Checkbox
            label="Mostrar áreas comunes"
            description="Parques, áreas verdes"
            checked={filters?.showCommonAreas}
            onChange={(e) => onFilterChange('showCommonAreas', e?.target?.checked)}
          />
          <Checkbox
            label="Mostrar vías"
            description="Calles y accesos"
            checked={filters?.showRoads}
            onChange={(e) => onFilterChange('showRoads', e?.target?.checked)}
          />
        </div>
      </div>
      {/* Results Summary */}
      <div className="p-4 bg-muted/50 rounded-xl">
        <div className="flex items-center gap-2 mb-2">
          <Icon name="Info" size={16} color="var(--color-primary)" />
          <span className="text-sm font-medium">Resultados</span>
        </div>
        <p className="text-sm text-muted-foreground">
          {filters?.resultsCount} lotes encontrados
        </p>
      </div>
    </div>
  );
};

export default FilterPanel;